import React, { ReactNode } from 'react';
import styles from './styles.module.css';
import { Typography, Button } from 'antd';
import * as translations from '../HelpGuideCard/strings';
import { getLangKey } from '../../models/Language';
import { onArticleClick } from '../../utils/HelpArticleButton';

const strings = translations[getLangKey()];

export type HelpGuideBannerProps = {
  bubbleContent?: ReactNode;
  header?: string;
  message?: ReactNode;
  vertical?: boolean;
  button?: {
    label: string;
    action?: () => void;
    link?: string;
    articleId?: number;
  };
};

export const HelpGuideBanner = ({
  bubbleContent = strings.help,
  header,
  message,
  vertical = false,
  button
}: HelpGuideBannerProps) => {
  return (
    <div className={styles.banner}>
      <span className={styles.bubble}>{bubbleContent}</span>
      <div
        className={`${styles.content} ${vertical ? styles.contentVertical : ''}`}
      >
        <div className={styles.text}>
          {header && (
            <Typography.Title level={5} className={styles.header}>
              {header}
            </Typography.Title>
          )}
          {message && (
            <Typography.Paragraph className={styles.message}>
              {message}
            </Typography.Paragraph>
          )}
        </div>
        {button && (
          <Button
            shape="round"
            className={styles.button}
            onClick={e => {
              e?.preventDefault();
              if (button.action) {
                button.action();
              } else if (button.articleId) {
                onArticleClick({ articleId: button.articleId });
              } else if (button.link) {
                window.open(button.link, '_blank');
              }
            }}
          >
            {button.label}
          </Button>
        )}
      </div>
    </div>
  );
};